'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$TestingAppPage$() {
}
export { $c_Lmealorama_AppRouter$TestingAppPage$ as $c_Lmealorama_AppRouter$TestingAppPage$ };
$p = $c_Lmealorama_AppRouter$TestingAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$TestingAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$TestingAppPage$() {
}
export { $h_Lmealorama_AppRouter$TestingAppPage$ as $h_Lmealorama_AppRouter$TestingAppPage$ };
$h_Lmealorama_AppRouter$TestingAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 166336576;
});
$p.m = (function() {
  return "TestingAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "TestingAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$TestingAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$TestingAppPage$, "mealorama.AppRouter$TestingAppPage$", ({
  Fz: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$TestingAppPage$ as $d_Lmealorama_AppRouter$TestingAppPage$ };
var $n_Lmealorama_AppRouter$TestingAppPage$;
function $m_Lmealorama_AppRouter$TestingAppPage$() {
  if ((!$n_Lmealorama_AppRouter$TestingAppPage$)) {
    $n_Lmealorama_AppRouter$TestingAppPage$ = new $c_Lmealorama_AppRouter$TestingAppPage$();
  }
  return $n_Lmealorama_AppRouter$TestingAppPage$;
}
export { $m_Lmealorama_AppRouter$TestingAppPage$ as $m_Lmealorama_AppRouter$TestingAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Testing-App-Page$.js.map
